import { GET_LESSONS } from "./__mocks__";
import { useTranslation } from "react-i18next";
import { CardContainer, Header } from "routes/createContent/components/styles";
import { LibraryItem } from "../../components/LibraryItem/LibraryItem";
import { LogoIcon } from "assets";
import { useHistory } from "react-router-dom";
import { Button } from "@material-ui/core";
import { Add } from "@material-ui/icons";
import { Area } from "types";

export const Lessons: React.VFC = () => {
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div>
      <Header>
        <h1>Lessons</h1>
        <Button color="primary" startIcon={<Add />} onClick={() => history.push(`${Area.CreateContent_Lessons}/new`)}>
          New lesson
        </Button>
      </Header>

      <p>List of lessons will be displayed here.</p>

      <CardContainer>
        {GET_LESSONS?.map(lesson => {
          const { id, title } = lesson;
          const caption = lesson.parts_count ? `${lesson.parts_count} ${t("usercourse.parts")}` : undefined;
          const image = lesson.image_url ? (
            <img alt="" src={`${lesson.image_url}`} height="100%" />
          ) : (
            <LogoIcon title="Joint Academy" />
          );

          return (
            <LibraryItem
              key={`lesson_${lesson.id}`}
              caption={caption}
              checked={false}
              id={id}
              image={image}
              tags={lesson.target_joints}
              title={title}
              onClick={() => {
                history.push(`${Area.CreateContent_Lessons}/${lesson.id}`);
              }}
            />
          );
        })}
      </CardContainer>
    </div>
  );
};
